import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ToastMsg from "../../components/common/ToastMsg";
import { ReactComponent as NetworkTowerIcon } from "../../assets/svg/network.svg";
import { Button } from "../../components/ui/button";

export const NetworkStatusHandler = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleOnline = () => {
            ToastMsg('success', "You are back online!");
            // ✅ Redirect if they’re on network error page
            if (window.location.pathname === "/networkError") {
                navigate("/home");
            }
        };

        const handleOffline = () => {
            ToastMsg('error', "You are offline! Please check your internet connection.");
            const token = sessionStorage.getItem("token");
            if (token) {
                navigate("/networkError");
            }
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, [navigate]);

    return null;
};

export const NetworkError = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // ✅ If internet is already available, prevent showing this page
        if (navigator.onLine) {
            navigate("/home");
        }
    }, [navigate]);

    const handleRetry = () => {
        if (navigator.onLine) {
            navigate("/home");
        } else {
            ToastMsg("error", "Still offline! Please check your internet connection.");
        }
    };

    return (
        <div className="flex flex-col justify-center items-center h-[80vh] gap-2 text-center">
            <NetworkTowerIcon className="-mt-3" />
            <div className="text-lg text-red-500 font-bold">No Internet Found!</div>
            <div className="text-sm text-gray-500">
                Oops! It seems you're offline. Please check your internet <br />
                connection and try again.
            </div>

            <Button
                onClick={handleRetry}
                className="bg-sidebar hover:bg-sidebar-primary dark:bg-blue-500 dark:hover:bg-blue-600"
            >
                Retry
            </Button>

            <p className="text-center">
                If the issue persists, contact our support team <br />
                at{" "}
                <a
                    href="mailto:support@hrbuddie.com?subject=Support Request&body=Hi Team, I need help with..."
                    className="text-[#04B7B1] hover:text-[#04B7B1]"
                >
                    support@hrzyra.com
                </a>
            </p>
        </div>
    );
};
